export const serviceName = {
  LANDING_MS: 'LANDING',
  ROLES_MS: 'ROLES',
  SKILLS_MS: 'SKILLS',
  COMMON_MS: 'COMMON',
  MASTER_MS: 'MASTER',
  BLOGS: 'BLOGS',
  CERTIFICATIONS_MS: 'CERTIFICATIONS',
  USER_ROLES_MS: 'USER-ROLES',
  INTEGRATION_MS: 'INTEGRATION',
  ACHIEVEMENTS_MS: 'ACHIEVEMENTS',
  PERFORMANCE_MS: 'PERFORMANCE',
  DARPAN_BRIDGE_MS: 'DARPAN-BRIDGE',
  DEAL_TRANSITION_MS: 'DEAL-TRANSITION',
  PROJECT_MS: 'PROJECT-MANAGEMENT',
  STAFF_AUGMENTATION_MS: 'STAFFING',
  RESELLER_SERVICE: 'RESELLER',
  IMD_SERVICE: 'IMD',
};
